const EMPLOYMENT_NAME = Object.freeze({
  employed: 'stylistScreen.addStylist.employed',
  selfEmployed: 'stylistScreen.addStylist.selfEmployed',
});

export default EMPLOYMENT_NAME;
